<ion-header [class]="!showHeader() ? 'hide-header ion-no-border' : ''">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="back-button" (click)="back()" *ngIf="showBackbtn()" [disabled]="movingBack">
        <ion-icon name="chevron-back-outline"></ion-icon>
        {{ 'CommonTexts.back' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title>{{ currentState?.headerText | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-slides mode="ios" [options]="authFlowSvc.slideOpts" #slider *ngIf="authFlowSvc.loaded" (ionSlidesDidLoad)="ionViewDidEnter()">
    <ion-slide *ngFor="let state of states; trackBy: id">
      <app-enter-pin
        *ngIf="state.screenCategory === 'enterPin'"
        [pin]="getPin(state)"
        [state]="state"
        [isOnline]="isOnline"
      ></app-enter-pin>
      <app-optional
        *ngIf="state.screenCategory === 'optional'"
        [isCurrent]="currentState?.id === state.id"
        [state]="state"
        [isOnline]="isOnline"
        (sendResetLink)="sendResetLink(true)"
      ></app-optional>
    </ion-slide>
  </ion-slides>
</ion-content>

<!-- preloaded toast icon -->
<ion-icon name="alert-circle" [hidden]="true"></ion-icon>
